import camelCase from 'lodash.camelcase';
import { Validation } from '../generated/graphql';

export function formatErrors(errors: Validation[]): Record<string, string> {
  return errors.reduce(
    (prev, err) => ({ ...prev, [camelCase(err.key)]: err.reason }),
    {},
  );
}
